/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
require("./plugins/jquery.hmc-offsite-links.js");
require("./plugins/jquery.hmc-address-links.js");
var ScrollEffects = require("./scroll-effects.js");
// require("./google-map.js");
require("./slick.min.js");
import SimpleLightbox from 'simplelightbox';

// utility function debounce from underscore.js
var debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this,
			args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			func.apply(context, args);
		}
	};
};

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // trigger nav overlay
        $('nav.mobile .menu-toggle').each( function(){
          $(this).click(function(e){
            e.preventDefault();
            $(this).blur();

            $('body').addClass('modal-active');
            $('.modal').removeClass('active');
            $('#fullscreen-nav').addClass('active');
          });
        });

		// cookies
		function setCookie(cName, cValue, expMin) {
			let date = new Date();
			date.setTime(date.getTime() + (expMin * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
		}
		function getCookie(name) {
			var dc = document.cookie;
			var prefix = name + "=";
			var begin = dc.indexOf("; " + prefix);
			if (begin == -1) {
				begin = dc.indexOf(prefix);
				if (begin != 0) return null;
			}
			else
			{
				begin += 2;
				var end = document.cookie.indexOf(";", begin);
				if (end == -1) {
				end = dc.length;
				}
			}
			return decodeURI(dc.substring(begin + prefix.length, end));
		}

		// home cta
		if ($(".topcta")[0]) {
			var ctaheight = $(".topcta").height();
			var closedTopCTA = getCookie("closedTopCTA");
			if (closedTopCTA != 1) {
				console.log('in1');
				$(".topcta").css('max-height',ctaheight);
				$(".topcta").css('opacity',1);
				$('.banner--featured-image').css('margin-top',ctaheight);
				$('.closetopcta').on("click",function() {
					$(".topcta").css('max-height','0px');
					$('.banner--featured-image').animate({ marginTop: '0px' , opacity: 0.5 }, 500);
					setCookie('closedTopCTA', 1, 10); // Remember Close
				});
			}
			else {
				$(".topcta").css('max-height','0px');
			}
		}
		else {
			$(".topcta").css('max-height','0px');
		}

        // init modal close buttons
        $('.modal .close').each(function() {
          $(this).click(function(e){
            $('body').removeClass('modal-active');
            $('.modal').removeClass('active');
          });
        });

        // initialize grid hover states
        $('.grid article').each(function() {
          $(this).hover(
            function() {
              $(this).addClass('hover');
            },
            function() {
              $(this).removeClass('hover');
            }
          );
        });

        // initialize map overlay
        $('#wpgmza_map').each(function() {
          $(this).wrap("<div class='map-wrapper'></div>");
          $(this).parent('.map-wrapper').prepend("<div class='overlay'><div><a class='btn'>Click to interact</a></div></div>");
          $('.map-wrapper .overlay').each(function() {
            $(this).click(function(){
              $(this).remove();
            });
          });
        });

        // initialize scroll effects
        ScrollEffects.initScrollEffects();

        // initialize list item hover state
        $('li[onclick]').hover(
          function() {
            $(this).addClass('hover');
          },
          function() {
            $(this).removeClass('hover');
          }
        );


		// Lightbox
		new SimpleLightbox('a.lightbox', {
			'captions': false,
			'disableRightClick': true,
			'showCounter': false,
		});

        // make offsite links load in new tab
        $('body').hmcOffsiteLinks();

        // initialize address links
        $('body').hmcAddressLinks();

				// button action on feature video/image section
				if ( $(".featured__scroll-hint").length > 0 ) {
					// Scroll down the mobile home page
					var projectScrollDown = function () {
						var header_offset = 50; // small header height
						var extra_offset = ($('.single-project').length > 0) ? 200 : 0;

						$('html, body').animate({
							scrollTop: window.innerHeight - header_offset - extra_offset
						}, 750);
					};

					$(".featured__scroll-hint").on("click", projectScrollDown);
				}

				// manually set the featured section height. 100vh doesn't work in mobile browsers due to address bar behavior.
				if ($('section.featured').length > 0) {
					var setFeaturedHeight = debounce(function(){
						var screenHeight = window.innerHeight;
						$("section.featured").css("height", screenHeight + "px");
					}, 15, true);
					window.onresize = setFeaturedHeight;

					setFeaturedHeight();
				}

				// home page project slider
				if ($('.project-slider__slides').length > 0) {
					// the slider element
					const $slick_gallery = $(".project-slider__slides");

					// is the slider currently animating
					var slick_gallery_is_animating = false;

					// start position of swipe action
					var slickSwipeStartY = 0;

					// shrink the header
					var shrinkHeader = function() {
						$('.banner').addClass('banner--small');
						$('.banner--featured-image .container').css('transform','translateY(-50%)');
					};

					// expand the header
					var growHeader = function() {
						$('.banner').removeClass('banner--small');
					};

					// use x and y mousewheel event data to navigate flickity
					var slickHandleWheelEvent = function(e, slick_instance, slick_is_animating) {
						// do not trigger a slide change if another is being animated
						if (!slick_is_animating) {
							// pick the larger of the two delta magnitudes (x or y) to determine nav direction
							var direction =
								Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

							// console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

							if (direction > 0) {
								// next slide
								slick_instance.slick("slickNext");
							} else {
								// prev slide
								slick_instance.slick("slickPrev");
							}
						}
					};

					// debounce the wheel event handling since trackpads can have a lot of inertia
					var slickHandleWheelEventDebounced = debounce(slickHandleWheelEvent, 100, true);

					// navigate using wheel/touchpad events
					var slickOnWheelEvent = function(e) {
						slickHandleWheelEventDebounced(
							e.originalEvent,
							$slick_gallery,
							slick_gallery_is_animating
						);
					};

					// before the slide is changed hide the caption
					var slickBeforeChange = function(event, slick, currentSlide, nextSlide) {
						$slick_gallery.find('.project-slide--active').removeClass("project-slide--active");
						slick_gallery_is_animating = true;

						// add animating class
						$slick_gallery.addClass('project-slider__slides--animating');

						shrinkHeader();
					};

					// hide the first slide and prevent the slider from immediately moving to the next one
					var slickRemoveFirstSlide = function() {
						// filter out the intro slide

						if ( $slick_gallery.slick('slickCurrentSlide') === 1 ) {
							// if we are on the second slide (index 1), we have to go to index 0 after removal to prevent the slider from jumping
							$slick_gallery.slick('slickFilter', ':not(.project-slide--introduction)').slick("slickGoTo", 0, true);
						} else {
							// scrolled backwards so we can just remove the first slide
							$slick_gallery.slick('slickFilter', ':not(.project-slide--introduction)');
						}
					};

					// after the slide is changed show the caption
					var slickAfterChange = function(event, slick, currentSlide, nextSlide) {

						$(slick.$slides[currentSlide]).addClass("project-slide--active");
						slick_gallery_is_animating = false;

						if ($(".project-slide--introduction").length > 0) {
							// can't do this here without slick wigging out so out a small delay on it. Needs to occur after the text reveal animation or things get choppy.
							setTimeout(slickRemoveFirstSlide, 500);

							// init dots and navigation
							$slick_gallery.slick("slickSetOption", {
								dots: true,
								autoplay: true,
								autoplaySpeed: 6000,
							});
						}

						// remove intro class which  determines if the intro is showing
						$slick_gallery.removeClass('project-slider__slides--introduction');

						// remove animating class
						$slick_gallery.removeClass('project-slider__slides--animating');

						// enable the transitional overlay
						$('.project-slider__overlay').removeClass('project-slider__overlay--disabled');

					};

					// is the slick slider initialized
					var slickIsInitialized = function() {
						return $slick_gallery.hasClass("slick-initialized");
					};

					// is the slick slider intro displayed
					var slickIsIntroductionDisplaying = function() {
						// dots are only enabled after the intro slide is hidden
						return $slick_gallery.hasClass('project-slider__slides--introduction');
					};

					// manually set the slide height. 100vh doesn't work in mobile browsers due to address bar behavior.
					var slickAdjustSlideHeight = function() {
						var screenHeight = window.innerHeight;


						if (slickIsInitialized()) {
							// set the slide height
							$(".project-slide").css("height", screenHeight + "px");

							// refresh slick
							$slick_gallery.slick("setPosition");
						} else {
							// set the slide height
							$(".project-slide").css("height", "");

							// the first slide is always full screen
							$(".project-slide--introduction").css("height", screenHeight + "px");
						}
					};

					// resize the header based on the slider state
					var slickResizeHeader = function() {
						if (slickIsInitialized()) {
							if (slickIsIntroductionDisplaying()) {
								growHeader();
							} else {
								shrinkHeader();
							}
						} else {
							// in mobile, let the normal scroll js handle this
						}
					};

					var slickSwipeStart = function(e) {
						slickSwipeStartY = e.originalEvent.changedTouches[0].screenY;
					};

					var slickSwipeEnd = function(e) {
						var dragTreshhold = 20;
						var slickSwipeEndY = e.originalEvent.changedTouches[0].screenY;
						var touchDiff = slickSwipeStartY - slickSwipeEndY;

						if (Math.abs(touchDiff) > dragTreshhold) {
							if ( touchDiff > 0 ) {
								$slick_gallery.slick("slickNext");
							} else {
								$slick_gallery.slick("slickPrev");
							}
						}
					};

					// handle key down event
					var slickKeyDown = function(e) {
						switch(e.which) {
							case 39: // right arrow
							case 40: // down arrow
								$slick_gallery.slick("slickNext");
								break;
							case 37: // left arrow
							case 38: // up arrow
								$slick_gallery.slick("slickPrev");
								break;
						}
					};

					// register slider events
					var slickRegisterEvents = function() {
						// set up events
						$slick_gallery.on("afterChange", slickAfterChange);
						$slick_gallery.on("beforeChange", slickBeforeChange);
						$(window).on("wheel", slickOnWheelEvent);

						// handle a vertical swipe action
						$slick_gallery.on('touchstart', slickSwipeStart);
						$slick_gallery.on('touchend', slickSwipeEnd);

						$(window).on('keydown', slickKeyDown);
					};

					// deregister slider events
					var slickDeregisterEvents = function() {
						$slick_gallery.off("afterChange");
						$slick_gallery.off("beforeChange");
						$(window).off("wheel");
						$slick_gallery.off('touchstart');
						$slick_gallery.off('touchend');
						$(window).off('keydown');
					};

					// update slideshow options (autoplay)
					var slickInitActiveSlideshow = function() {
						// move to next slide
						$slick_gallery.slick("slickGoTo", 1, false);

						// init dots and navigation
						$slick_gallery.slick("slickSetOption", {
							dots: true,
							autoplay: true,
							autoplaySpeed: 6000,
						});
					};

					// Scroll down the mobile home page
					var homeScrollToProjects = function () {
						var mobile_header_height = 50;

						$('html, body').animate({
							scrollTop: window.innerHeight - mobile_header_height
						}, 500);
					};

					// link to first slide
					var url = window.location.search;
					if (url == '?work') {
						setTimeout(function() {
							$slick_gallery.slick("slickNext")
						}, 1);
					}
					else {
						$('a[href*="?work"]').on("click",function(e) {
							e.preventDefault();
							$slick_gallery.slick("slickNext");
						});
					}

					// enable/disable the slider based on screen width
					var slickInitIntroSlideshow = function() {
						var screenWidth = window.innerWidth;
						var mobileBreakpoint = 800;

						slickRegisterEvents();

						// size the slides
						slickAdjustSlideHeight();

						if (screenWidth >= mobileBreakpoint) {
							if (!slickIsInitialized()) {
								slick_gallery_is_animating = false;

								// init slider, displays first slide only and not way to advance until the button is clicked
								$slick_gallery.slick({
									accessibility: false, // this would allow arrow nav but it cannot be reinitialized later
									arrows: false,
									dots: false,
									dotsClass: 'gallery-dots',
									speed: 1000,
									vertical: true,
									cssEase: "cubic-bezier(.77,0,.175,1)",
									touchThreshold: 25,
									swipe: false,
									verticalSwiping: false,
									pauseOnFocus: false,
									pauseOnHover: false,
									pauseOnDotsHover: true
								});

								// add intro class so we can determine if the intro is showing
								$slick_gallery.addClass('project-slider__slides--introduction');

								// enable the transitional overlay
								$('.project-slider__overlay').addClass('project-slider__overlay--disabled');

								// size the slides
								slickAdjustSlideHeight();

								// start the normal slideshow when the button is clicked
								$(".project-slide__trigger").off("click"); // prevent double event attachment
								$(".project-slide__trigger").on("click", slickInitActiveSlideshow);
							}
						} else {
							// disable intro button
							$(".project-slide__trigger").off("click");
							$(".project-slide__trigger").on("click", homeScrollToProjects);

							if (slickIsInitialized()) {
								$slick_gallery.slick('slickUnfilter').slick("unslick");

								// deregister events
								slickDeregisterEvents();
							}
						}

						slickResizeHeader();
					};

					// debounce the responsive check
					var slickInitIntroSlideshowDebounced = debounce(slickInitIntroSlideshow, 15, true);

					// Since we are manaually setting the height, trigger slide resize on window resize event.
					window.onresize = slickInitIntroSlideshowDebounced;

					// show the slider
					slickAdjustSlideHeight();
					slickInitIntroSlideshow();
				}
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
